import MenuService from './MenuService'

export default MenuService
